<div class="produtividade-filter sgt-filter">
    
    <div class="sgt-filter-quick">           
        <!-- Vigência --> 
        <div class="sgt-filter-quick-item">
            <sgt-datepicker 
                [(ngModel)]="filter.periodicidade.data" 
                [(startDate)]="filter.periodicidade.dataInicio"
                [(endDate)]="filter.periodicidade.dataTermino"
                name="dataFilter" 
                id="dataFilter"
                #dataFilter="ngModel" #dataDatepicker [ngControl]="dataFilter" 
                [mode]="dataDatepickerMode"
                [showBtnCalendar]="false"
                inputPrependText="Vigência"
                [withNavigation]="true"
                [showPeriodicidadeDiaria]="true"
                [showPeriodicidadeMensal]="true"
                [showPeriodicidadeTrimestral]="true"
                [showPeriodicidadeSemestral]="true"
                [showPeriodicidadeAnual]="true"   
                [showPeriodicidadePeriodo]="true"             
                [(periodicidade)]="filter.periodicidade.periodicidade"
                [(mes)]="filter.periodicidade.mes"
                [(trimestre)]="filter.periodicidade.trimestre"
                [(semestre)]="filter.periodicidade.semestre"
                [(ano)]="filter.periodicidade.ano"                
                (ngModelChange)="onChangeData()"
                (startDateChange)="onChangeDataInicio()"
                (endDateChange)="onChangeDataTermino()">
            </sgt-datepicker> 
        </div>

        <!-- Indicadores de Cross Sell-->
        <div class="sgt-filter-quick-item">
            <sgt-cross-sell-multiselect
                [(crossSells)]="filter.crossSells"
                (crossSellsChange)="onChangeCrossSells()"
                defaultTitle="Cross Sell"
                [isShowSem]="false"
                [disabled]="!isFilterInitialized">
            </sgt-cross-sell-multiselect>            
        </div>        

        <!-- Statuses Pedidos -->
        <div class="sgt-filter-quick-item">
            <sgt-pedido-status-multiselect
                [(status)]="filter.pedidosStatuses"
                (statusChange)="onChangeStatusesPedidos()"
                defaultTitle="Status dos Pedidos"
                [disabled]="!isFilterInitialized">
            </sgt-pedido-status-multiselect>           
        </div>                

        <!-- Classificações de Clientes -->
        <div class="sgt-filter-quick-item">
            <sgt-classificacao-tipo-multiselect
                [(idsClassificacoes)]="filter.idsClassificacoesClientes"
                (idsClassificacoesChange)="onChangeClassificacoesClientes()"
                [(nullOption)]="filter.classificacaoClienteNull"
                [showNullOption]="true"
                [tipoClassificacaoCadastroCliente]="true"
                defaultTitle="Segmentos de Clientes"
                [disabled]="!isFilterInitialized">
            </sgt-classificacao-tipo-multiselect>                
        </div> 
        
        <!-- Classificações de Itens -->
        <div class="sgt-filter-quick-item">
            <sgt-classificacao-tipo-multiselect
                [(idsClassificacoes)]="filter.idsClassificacoesItens"
                (idsClassificacoesChange)="onChangeClassificacoesItens()"
                [(nullOption)]="filter.classificacaoItemNull"
                [showNullOption]="true"
                [tipoClassificacaoCadastroItem]="true"
                [pullRight]="true"
                defaultTitle="Segmentos de Itens"
                checked="Segmento de Item"
                checkedPlural="Segmentos de Itens"
                [disabled]="!isFilterInitialized">
            </sgt-classificacao-tipo-multiselect>
        </div>         


        <!-- Representante -->
        <div class="sgt-filter-quick-item" *ngIf="!isRepresentante">
            <sgt-representante-multiselect
                [(idsRepresentantes)]="filter.idsRepresentantes"
                (idsRepresentantesChange)="onChangeRepresentantes()"
                defaultTitle="Representantes"
                [(somenteAtivos)]="filter.somenteRepresentantesAtivos"
                (somenteAtivosChange)="onChangeRepresentantes()"
                [showModalidadesComerciais]="true"
                [(modalidadesComerciais)]="filter.modalidadesComerciaisRepresentantes"
                (modalidadesComerciaisChange)="onChangeRepresentantes()"
                [disabled]="!isFilterInitialized">
            </sgt-representante-multiselect>      
        </div> 

        <!-- Atendentes -->
        <div class="sgt-filter-quick-item" *ngIf="isAdministrador">
            <sgt-usuario-multi-select
                [(ngModel)]="filter.idsAtendentes"
                (ngModelChange)="onChangeAtendentes()"
                name="produtividadeFilterAtendentes"
                [perfil]="EnumUsuarioPerfil.ATENDENTE"
                [situacao]="EnumSituacao.ATIVO"
                [settings]="{
                    placeholder: 'Atendentes',
                    singular: 'Atendente',
                    plural: 'Atendentes',
                    showFooter: false
                }"
                [disabled]="!isFilterInitialized">
            </sgt-usuario-multi-select>
        </div>

        <!-- Gerentes -->
        <div class="sgt-filter-quick-item" *ngIf="isAdministrador">
            <sgt-usuario-multi-select
                [(ngModel)]="filter.idsGerentes"
                (ngModelChange)="onChangeGerentes()"
                name="produtividadeFilterGerentes"
                [perfil]="EnumUsuarioPerfil.GERENTE"
                [situacao]="EnumSituacao.ATIVO"
                [settings]="{
                    placeholder: 'Gerentes',
                    singular: 'Gerente',
                    plural: 'Gerentes',
                    showFooter: false
                }"
                [disabled]="!isFilterInitialized">
            </sgt-usuario-multi-select>
         </div>

        <div class="sgt-filter-quick-actions">
            <div class="btn-group">
                <button type="button" class="btn btn-light" (click)="refresh()" title="Atualizar"
                    [disabled]="!isFilterInitialized">
                    <i class="fas fa-sync"></i>
                </button>
                <button type="button" class="btn btn-light" (click)="clear()" title="Limpar filtro e atualizar"
                    [disabled]="!isFilterInitialized">
                    <i class="fas fa-eraser" aria-hidden="true"></i>
                </button>
                <button type="button" class="btn" [class.btn-light]="!filter.isFilterDirty" [class.btn-danger]="filter.isFilterDirty"
                    (click)="toggleCollapse()" title="Filtro avançado"
                    [disabled]="!isFilterInitialized">
                    <ng-template [ngIf]="isFilterInitialized">
                        <i class="fas fa-filter" aria-hidden="true"></i>
                        <i [class]="collapseIcon" aria-hidden="true"></i>
                    </ng-template>
                    <ng-template [ngIf]="isFilterInitializing">
                        <i class='fas fa-spinner fa-pulse'></i>
                    </ng-template>
                </button>
            </div>          
        </div>
    </div>  
    
    <div class="sgt-filter-collapse" #filterCollapse>
        <div class="row">
            <div class="form-group col-12 col-md">
                <label for="produtividadeFilterCliente" class="col-form-label">Cliente</label>
                <sgt-typeahead-cliente-pessoa [(ngModel)]="filter.pessoa" name="produtividadeFilterCliente" id="produtividadeFilterCliente"
                    #produtividadeFilterCliente="ngModel" [ngControl]="produtividadeFilterCliente"
                    (entitySelected)="onChangeCliente($event)"
                    (clearEntity)="clearCliente()">
                </sgt-typeahead-cliente-pessoa>
            </div> 
        </div> 
    </div>
</div>

